export const REINITIALIZE_STORE_STATE = 'REINITIALIZE_STORE_STATE';
export const ADD_FLASH_MESSAGE = 'ADD_FLASH_MESSAGE';
export const CLEAR_FLASH_MESSAGE = 'CLEAR_FLASH_MESSAGE';

/**
 * Account
 */
export const SET_CURRENT_ACCOUNT = 'SET_CURRENT_ACCOUNT';
export const SET_TOTAL_READING_DATES = 'SET_TOTAL_READING_DATES';

/**
 * Invitation
 */
export const SET_INVITATIONS = 'SET_INVITATIONS';
export const SET_CURRENT_INVITATION_PAGE = 'SET_CURRENT_INVITATION_PAGE';
export const SET_CURRENT_INVITATION = 'SET_CURRENT_INVITATION';
export const CLEAR_INVITATIONS_AFTER_PAGE = 'CLEAR_INVITATIONS_AFTER_PAGE';

/**
 * Users
 */
export const SET_USERS = 'SET_USERS';
export const SET_CURRENT_USER_PAGE = 'SET_CURRENT_USER_PAGE';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const CLEAR_USERS_AFTER_PAGE = 'CLEAR_USERS_AFTER_PAGE';
export const SET_PARENTS = 'SET_PARENTS';
export const SET_CURRENT_PARENT_PAGE = 'SET_CURRENT_PARENT_PAGE';
export const SET_CURRENT_PARENT = 'SET_CURRENT_PARENT';
export const CLEAR_PARENTS_AFTER_PAGE = 'CLEAR_PARENTS_AFTER_PAGE';

/**
 * School
 */
export const SET_SCHOOLS = 'SET_SCHOOLS';
export const SET_CURRENT_SCHOOL_PAGE = 'SET_CURRENT_SCHOOL_PAGE';
export const SET_CURRENT_SCHOOL = 'SET_CURRENT_SCHOOL';
export const CLEAR_SCHOOLS_AFTER_PAGE = 'CLEAR_SCHOOLS_AFTER_PAGE';
export const SET_SCHOOL_FACULTIES = 'SET_SCHOOL_FACULTIES';
export const SET_CURRENT_SCHOOL_FACULTY_PAGE = 'SET_CURRENT_SCHOOL_FACULTY_PAGE';
export const SET_CURRENT_SCHOOL_FACULTY = 'SET_CURRENT_SCHOOL_FACULTY';
export const CLEAR_SCHOOL_FACULTIES_AFTER_PAGE = 'CLEAR_SCHOOL_FACULTIES_AFTER_PAGE';

/**
 * Classroom
 */
export const SET_CLASSROOMS = 'SET_CLASSROOMS';
export const SET_CURRENT_CLASSROOM_PAGE = 'SET_CURRENT_CLASSROOM_PAGE';
export const SET_CURRENT_CLASSROOM = 'SET_CURRENT_CLASSROOM';
export const CLEAR_CLASSROOMS_AFTER_PAGE = 'CLEAR_CLASSROOMS_AFTER_PAGE';
export const SET_CLASSROOM_READERS = 'SET_CLASSROOM_READERS';
export const SET_CURRENT_CLASSROOM_READER_PAGE = 'SET_CURRENT_CLASSROOM_READER_PAGE';
export const SET_CURRENT_CLASSROOM_READER = 'SET_CURRENT_CLASSROOM_READER';
export const CLEAR_CLASSROOM_READERS_AFTER_PAGE = 'CLEAR_CLASSROOM_READERS_AFTER_PAGE';
export const SET_CLASSROOM_TEACHERS = 'SET_CLASSROOM_TEACHERS';
export const SET_CURRENT_CLASSROOM_TEACHER_PAGE = 'SET_CURRENT_CLASSROOM_TEACHER_PAGE';
export const SET_CURRENT_CLASSROOM_TEACHER = 'SET_CURRENT_CLASSROOM_TEACHER';
export const CLEAR_CLASSROOM_TEACHERS_AFTER_PAGE = 'CLEAR_CLASSROOM_TEACHERS_AFTER_PAGE';

/**
 * Subscription
 */
export const SET_ACTIVATED_SUBSCRIPTIONS = 'SET_ACTIVATED_SUBSCRIPTIONS';
export const SET_CURRENT_ACTIVATED_SUBSCRIPTION_PAGE = 'SET_CURRENT_ACTIVATED_SUBSCRIPTION_PAGE';
export const SET_CURRENT_ACTIVATED_SUBSCRIPTION = 'SET_CURRENT_ACTIVATED_SUBSCRIPTION';
export const CLEAR_ACTIVATED_SUBSCRIPTIONS_AFTER_PAGE = 'CLEAR_ACTIVATED_SUBSCRIPTIONS_AFTER_PAGE';
export const SET_PENDING_SUBSCRIPTIONS = 'SET_PENDING_SUBSCRIPTIONS';
export const SET_CURRENT_PENDING_SUBSCRIPTION_PAGE = 'SET_CURRENT_PENDING_SUBSCRIPTION_PAGE';
export const SET_CURRENT_PENDING_SUBSCRIPTION = 'SET_CURRENT_PENDING_SUBSCRIPTION';
export const CLEAR_PENDING_SUBSCRIPTIONS_AFTER_PAGE = 'CLEAR_PENDING_SUBSCRIPTIONS_AFTER_PAGE';
export const SET_CLASSROOM_SUBSCRIPTIONS = 'SET_CLASSROOM_SUBSCRIPTIONS';
export const SET_CURRENT_CLASSROOM_SUBSCRIPTION_PAGE = 'SET_CURRENT_CLASSROOM_SUBSCRIPTION_PAGE';
export const SET_CURRENT_CLASSROOM_SUBSCRIPTION = 'SET_CURRENT_CLASSROOM_SUBSCRIPTION';
export const CLEAR_CLASSROOM_SUBSCRIPTIONS_AFTER_PAGE = 'CLEAR_CLASSROOM_SUBSCRIPTIONS_AFTER_PAGE';

/**
 * Order
 */
export const SET_ORDERS = 'SET_ORDERS';
export const SET_CURRENT_ORDER_PAGE = 'SET_CURRENT_ORDER_PAGE';
export const SET_CURRENT_ORDER = 'SET_CURRENT_ORDER';
export const CLEAR_ORDERS_AFTER_PAGE = 'CLEAR_ORDERS_AFTER_PAGE';

/**
 * Reading
 */
export const SET_READINGS = 'SET_READINGS';
export const SET_CURRENT_READING = 'SET_CURRENT_READING';
export const CLEAR_READINGS = 'CLEAR_READINGS';
export const CLEAR_CURRENT_READING = 'CLEAR_CURRENT_READING';
export const SET_ADMIN_READINGS = 'SET_ADMIN_READINGS';
export const SET_CURRENT_ADMIN_READING_PAGE = 'SET_CURRENT_ADMIN_READING_PAGE';
export const SET_CURRENT_ADMIN_READING = 'SET_CURRENT_ADMIN_READING';
export const CLEAR_ADMIN_READINGS_AFTER_PAGE = 'CLEAR_ADMIN_READINGS_AFTER_PAGE';

/**
 * Book
 */
export const SET_BOOKS = 'SET_BOOKS';
export const SET_CURRENT_BOOK_PAGE = 'SET_CURRENT_BOOK_PAGE';
export const SET_CURRENT_BOOK = 'SET_CURRENT_BOOK';
export const CLEAR_BOOKS_AFTER_PAGE = 'CLEAR_BOOKS_AFTER_PAGE';

/**
 * Book
 */
export const SET_TIPS = 'SET_TIPS';
export const SET_CURRENT_TIP_PAGE = 'SET_CURRENT_TIP_PAGE';
export const SET_CURRENT_TIP = 'SET_CURRENT_TIP';
export const CLEAR_TIPS_AFTER_PAGE = 'CLEAR_TIPS_AFTER_PAGE';
export const SET_SCROLLABLE_TIPS = 'SET_SCROLLABLE_TIPS';
export const CLEAR_SCROLLABLE_TIPS = 'CLEAR_SCROLLABLE_TIPS';

/**
 * Award
 */
export const SET_AWARDS = 'SET_AWARDS';
export const SET_CURRENT_AWARD_PAGE = 'SET_CURRENT_AWARD_PAGE';
export const SET_CURRENT_AWARD = 'SET_CURRENT_AWARD';
export const CLEAR_AWARDS_AFTER_PAGE = 'CLEAR_AWARDS_AFTER_PAGE';

/**
 * Message
 */
export const SET_MESSAGES = 'SET_MESSAGES';
export const SET_CURRENT_MESSAGE_PAGE = 'SET_CURRENT_MESSAGE_PAGE';
export const SET_CURRENT_MESSAGE = 'SET_CURRENT_MESSAGE';
export const CLEAR_MESSAGES_AFTER_PAGE = 'CLEAR_MESSAGES_AFTER_PAGE';
